import React from 'react';

const PageSelector = ({ maxPagesPerPdf, onChange }) => {
  return (
    <div className="mb-2">
      <div className="accordion accordion-flush" id="pageSelectorAccordion">
        <div className="accordion-item">
          <h2 className="accordion-header" id="pageSelectorHeading">
            <button 
              className="accordion-button collapsed py-2 px-0" 
              type="button" 
              data-bs-toggle="collapse" 
              data-bs-target="#pageSelectorCollapse" 
              aria-expanded="false" 
              aria-controls="pageSelectorCollapse"
            >
              <i className="bi bi-file-earmark-pdf me-2 text-danger"></i>
              <span className="fw-semibold">Páginas a Procesar por PDF</span>
              <span className="badge bg-primary ms-2">{maxPagesPerPdf} página{maxPagesPerPdf > 1 ? 's' : ''}</span>
            </button>
          </h2>
          <div 
            id="pageSelectorCollapse" 
            className="accordion-collapse collapse" 
            aria-labelledby="pageSelectorHeading" 
            data-bs-parent="#pageSelectorAccordion"
          >
            <div className="accordion-body px-0 py-3">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <label className="form-label fw-medium mb-0">
                  Páginas por PDF
                </label>
                <div className="d-flex align-items-center">
                  <i className="bi bi-info-circle text-info me-1"></i>
                  <small className="text-info-emphasis mb-0">
                    <strong>Cada página = 1 documento</strong>
                  </small>
                </div>
              </div>
              
              <div className="input-group">
                <input 
                  type="number" 
                  className="form-control" 
                  value={maxPagesPerPdf}
                  onChange={(e) => onChange(Math.max(1, Math.min(10, parseInt(e.target.value) || 1)))}
                  min="1" 
                  max="10"
                />
                <span className="input-group-text bg-light">páginas</span>
              </div>
              
              <div className="mt-2">
                <small className="text-muted">
                  Para PDFs multipágina, solo se procesa{maxPagesPerPdf > 1 ? 'n' : ''} la{maxPagesPerPdf > 1 ? 's' : ''} primera{maxPagesPerPdf > 1 ? 's' : ''} {maxPagesPerPdf} página{maxPagesPerPdf > 1 ? 's' : ''}.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageSelector;
